
    const data = {"name":"src/core/icons/arrow-up-small","data":{"width":"10.998","height":"7","viewBox":"0 0 10.998 7","data":"<path pid=\"0\" d=\"M555.047 624.153a1 1 0 0 0-.744.332l-4.5 5a1 1 0 1 0 1.487 1.337l3.756-4.174 3.755 4.174a1 1 0 1 0 1.487-1.337l-4.5-5a1 1 0 0 0-.741-.332Z\" transform=\"translate(-549.548 -624.153)\" _fill=\"#041334\"/>","originalColors":[{"type":"fill","color":"#041334"}],"stopColors":[]}}

            export default data
            